import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { WebServicesService } from '../web-services/web-services.service';
import { CustomerTree } from './customer-tree.model';
import { NotificationService } from '../../service/notification/notification.service';

@Injectable({
	providedIn: 'root'
})
export class CustomerTreeService {

	constructor(
		private notificationService: NotificationService,
		private translateService: TranslateService,
		private webServicesService: WebServicesService
	) { }

	/* Appels aux webServices */

	public getCustomerTree(): Promise<CustomerTree> {
		console.log('RÃ©cupÃ©ration de l\'arborescence client');
		return this.webServicesService.getEntity<CustomerTree>('/customer_tree')
			.catch(error => {
				this.notificationService.showError(this.translateService.instant('GET_CUSTOMER_TREE_ERROR'));
				return Promise.reject(error);
			})
	}

	public getCustomerTreeElement(customerTreeId: number): Promise<CustomerTree> {
		console.log('RÃ©cupÃ©ration de l\'Ã©lÃ©ment ' + customerTreeId + 'dans l\'arborescence client');
		return this.webServicesService.getEntity<CustomerTree>('/customer_tree/' + customerTreeId)
			.catch(error => {
				this.notificationService.showError(this.translateService.instant('GET_CUSTOMER_TREE_ERROR'));
				return Promise.reject(error);
			})
	}

	// TODO: rÃ©cupÃ©rer un Customer Tree
	public putCustomerTreeElement(name: String, alternateName: string, parentId: number, languages: string, timeZone: string, type: string): Promise<number> {
		console.log('Ajout d\'un Ã©lÃ©ment dans l\'arborescence client');
		let json = {
			name: name,
			alternateName: alternateName,
			languages: languages,
			timeZone: timeZone, 
			type: type
		}
		return this.webServicesService.put<number>('/customer_tree/' + parentId, json)
			.catch(error => {
				this.notificationService.showError(this.translateService.instant('ERROR'));
				return Promise.reject(error);
			})
	}

	public patchCustomerTreeElement(id: number, name: string, alternateName: string, parentId: number, languages: string, timeZone: string, type:string): Promise<CustomerTree> {
		console.log('Modification de l\'Ã©lÃ©ment ' + id + ' dans l\'arborescence client');
		let json = {
			name: name,
			alternateName: alternateName,
			parentId: parentId,
			languages: languages,
			timeZone: timeZone,
			type: type
		}
		return this.webServicesService.patch<CustomerTree>('/customer_tree/' + id, json)
			.catch(error => {
				this.notificationService.showError(this.translateService.instant('ERROR'));
				return Promise.reject(error);
			})
	}

	public deleteCustomerTreeLevel(levelId: number) {
		console.log("Suppression du niveau " + levelId + ' dans l\'arborescence client');
		return this.webServicesService.delete('/customer_tree/' + levelId)
			.catch(error => {
				this.notificationService.showError(this.translateService.instant('ERROR'));
				return Promise.reject(error);
			})
	}
}
